import { render, staticRenderFns } from "./VoteTable.vue?vue&type=template&id=c391c166&scoped=true&"
import script from "./VoteTable.vue?vue&type=script&lang=js&"
export * from "./VoteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c391c166",
  null
  
)

export default component.exports